import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Music from './components/Music';
import Shows from './components/Shows';
import Band from './components/Band';
import Contact from './components/Contact';
import Footer from './components/Footer';
import RoosterAnimation from './components/RoosterAnimation';
import './App.css';

// Custom theme with brown/orange color scheme
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#7B542F', // Brown
      dark: '#B6771D', // Dark orange
      light: '#FF9D00', // Bright orange
    },
    secondary: {
      main: '#FFCF71', // Light yellow-orange highlight
    },
    background: {
      default: '#0a0a0a',
      paper: '#121212',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#F5F5F5',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", sans-serif',
    h1: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 700,
      letterSpacing: '0.1em',
    },
    h2: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
      letterSpacing: '0.08em',
    },
    h3: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
    },
    h4: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
    },
    h6: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
    },
    button: {
      fontFamily: '"Montserrat", sans-serif',
      fontWeight: 600,
    },
  },
});

function App() {
  // Check if animation has been shown in this session
  const hasSeenAnimation = sessionStorage.getItem('hasSeenAnimation') === 'true';
  const [animationComplete, setAnimationComplete] = React.useState(hasSeenAnimation);

  // Inject CSS variables for global styles
  React.useEffect(() => {
    document.documentElement.style.setProperty('--color-primary-main', theme.palette.primary.main);
    document.documentElement.style.setProperty('--color-primary-dark', theme.palette.primary.dark);
    document.documentElement.style.setProperty('--color-primary-light', theme.palette.primary.light);
    document.documentElement.style.setProperty('--color-secondary-main', theme.palette.secondary.main);
  }, []);

  const handleAnimationComplete = () => {
    setAnimationComplete(true);
    sessionStorage.setItem('hasSeenAnimation', 'true');
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {!hasSeenAnimation && <RoosterAnimation onComplete={handleAnimationComplete} />}
      <div className="App">
        <Navbar showLogo={animationComplete} />
        <Hero showLogo={animationComplete} />
        <Music />
        <Shows />
        <Band />
        <Contact />
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
